import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useIsAuthenticated } from "@azure/msal-react";
import Logo from '../assets/lendox_logo_white.svg'

export default function Login() {
  const isAuthenticated = useIsAuthenticated();
  const [loginClicked, setLoginClicked] = useState(false)

  if (loginClicked || isAuthenticated) {
    return <Navigate to="/home" />
  }

  return (
    <section className="lox-login hero is-primary is-fullheight pt-0">
      <div className="hero-body pt-0">
        <div className="container">
          <div className="columns is-centered mb-5">
            <div className="column is-2">
              <img
                className="image"
                alt="logo"
                src={Logo}
              />
            </div>
          </div>
          <div className="columns is-centered">
            <article className="message is-link">
              <div className="message-header is-justify-content-center">
                <p className="is-size-4">Sign in</p>
              </div>
              <div className="message-body">
                <div className="columns is-multiline">
                  <div className="column is-full has-text-centered py-6 my-3">
                    You are not currently logged in, please click the button below to
                    login via Microsoft.
                  </div>
                  <div className="column is-full has-text-centered py-4">
                    <button
                      onClick={() => {
                        setLoginClicked(true)
                      }}
                      type="button"
                      className="button is-primary p-4"
                    >
                      Login via Microsoft
                    </button>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}
